/**
 * Whether the person used the app since the last session check (FR-ADMIN-047: activity moves the idle timeout, an
 * open tab alone does not). The session store checks `/me` on a timer; each check tells the identity service whether
 * there was input since the previous one, so drawing or browsing counts even when it never reaches the service.
 */

/** The header the identity service reads (`crates/services/identity/src/session/mod.rs`). */
export const ACTIVITY_HEADER = "X-Orthos-Activity";
export const ACTIVE = "user";
export const IDLE = "none";

const INPUT_EVENTS = ["pointerdown", "keydown", "wheel", "touchstart"] as const;

export interface ActivityTracker {
  /** True when there was input since the last call; the first call counts the page load. */
  take(): boolean;
}

export function createActivityTracker(
  target: Pick<EventTarget, "addEventListener"> | undefined,
): ActivityTracker {
  let active = true;
  const mark = () => {
    active = true;
  };
  for (const type of INPUT_EVENTS)
    target?.addEventListener(type, mark, { capture: true, passive: true });
  return {
    take() {
      const was = active;
      active = false;
      return was;
    },
  };
}
